if (!customElements.get('sticky-add-to-cart')) {
  class StickyAddToCart extends HTMLElement {
    constructor() {
      super();
      this.stickyBar = this.querySelector('[data-sticky-add-to-cart]');
    }

    connectedCallback() {
      if (!this.stickyBar) return;

      const initObserver = () => {
        const target =
          document.querySelector('product-form-component') ||
          document.querySelector('add-to-cart-component');

        if (!target) return;

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this.stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
            });
          },
          { root: null, threshold: 0.5 }
        );

        this.observer.observe(target);
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initObserver);
      } else {
        initObserver();
      }

      const triggerBtn = this.querySelector('[data-sticky-cart-trigger]');
      if (triggerBtn) {
        triggerBtn.addEventListener('click', () => {
          const atcButton = document.querySelector('add-to-cart-component button[name="add"]');
          if (atcButton) {
            atcButton.click();
          } else {
            const form = document.querySelector('[data-type="add-to-cart-form"]');
            if (form) form.requestSubmit();
          }
        });
      }
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  }

  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
